"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLoginLogList = getLoginLogList;
var _request = _interopRequireDefault(require("@/utils/request"));
function getLoginLogList(data) {
  return (0, _request.default)({
    url: '/api/v1/common/LoginLog',
    method: 'get',
    params: data
  });
}